export const EnrolmentSegment = {
  ALL: "all",
  JUNIFER_ERRORS: "juniferErrors",
  NON_JUNIFER_ERRORS: "nonJuniferErrors",
} as const
export type EnrolmentSegmentType =
  (typeof EnrolmentSegment)[keyof typeof EnrolmentSegment]
